<template>
  <VCard>
    <VContainer>
      <VLayout>
        <VFlex md12>
          <VTextField
            v-if="clienteNome != ''"
            v-model="clienteNome"
            label="Cliente"
            prepend-icon="group"
            disabled
          />
          <AutocompleteCliente
            v-else
            v-model="cliente"
            :permitir-adicionar="false"
            endpoint="evolucao/busca"
            :disabled="desabilitarFiltro"
          />
          <VCardTitle class="title">
            Serviços
            <VSpacer></VSpacer>
            <VTextField
              v-model="busca"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
              clearable
            ></VTextField>
          </VCardTitle>
          <VDataTable
            :items="cliente.servicos"
            :headers="cabecalhos"
            :pagination.sync="paginacao"
            :search="busca"
          >
            <template v-slot:items="props">
              <tr @click="abrirEvolucao(props.item)" class="clicavel">
                <td>
                  {{ props.item.nome }}
                </td>
                <td>
                  {{ formatarData(props.item.aquisicao, "-") }}
                </td>
                <td>
                  {{ formatarData(props.item.ultimaExecucao, "-") }}
                </td>
                <td>
                  {{ props.item.sessoesExecutadas }}
                </td>
                <td>
                  {{ props.item.sessoesAdquiridas }}
                </td>
                <td>
                  {{ props.item.formulariosPreenchidos ? "Sim" : "Não" }}
                </td>
              </tr>
            </template>
          </VDataTable>
        </VFlex>
      </VLayout>
    </VContainer>
    <VDialog v-model="dialog" max-width="1000px" persistent>
      <VCard>
        <VToolbar dark color="primary">
          Evolução: {{ id }}
          <VSpacer></VSpacer>
          <VToolbarItems>
            <VBtn icon dark @click="dialog = false">
              <VIcon>close</VIcon>
            </VBtn>
          </VToolbarItems>
        </VToolbar>
        <VCardText>
          <EvolucaoTratamento :id="id" :footer="false" />
        </VCardText>
        <VCardActions class="bottom">
          <VSpacer></VSpacer>
          <VBtn color="primary" flat @click="dialog = false">Fechar</VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </VCard>
</template>

<script>
import AutocompleteCliente from "../AutocompleteCliente";
import datas from "@/mixins/datas";
import alerts from "@/common/alerts";
import numeros from "../../mixins/numeros";
import ApiService from "../../common/api.service";
import EvolucaoTratamento from "./EvolucaoTratamento";

export default {
  mixins: [datas, numeros],
  name: "ServicosContratados",
  components: { AutocompleteCliente, EvolucaoTratamento },
  props: {
    idCliente: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      id: 0,
      dialog: false,
      clienteNome: "",
      desabilitarFiltro: false,
      cliente: {
        servicos: [],
      },
      paginacao: {
        page: 1,
        rowsPerPage: 5,
        sortBy: "ultimaExecucao",
        descending: false,
      },
      busca: null,
      cabecalhos: [
        {
          text: "Serviço",
          value: "nome",
        },
        {
          text: "Contratação",
          value: "aquisicao",
        },
        {
          text: "Última execução",
          value: "ultimaExecucao",
        },
        {
          text: "Executadas",
          value: "sessoesExecutadas",
          sortable: false,
        },
        {
          text: "Contratadas",
          value: "sessoesAdquiridas",
          sortable: false,
        },
        {
          text: "Possui fichas",
          value: "id",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    idCliente() {
      const idCliente = this.idCliente;
      if (idCliente) {
        this.desabilitarFiltro = true;
        this.buscarServicosPorId(idCliente);
      }
    },
  },
  methods: {
    async buscarServicosPorId(idCliente) {
      const dados = (await ApiService.get(`/evolucao/buscarPorId/${idCliente}`))
        .data;
      if (dados.length > 0) {
        this.clienteNome = dados[0].nome;
        this.cliente.servicos = dados[0].servicos;
      }
    },
    abrirEvolucao(servico) {
      if (servico.formulariosPreenchidos) {
        this.dialog = true;
        this.id = servico.id;
      } else 
        alerts.exibirInformacao("Nenhuma ficha preenchida para este serviço");
    },
  },
};
</script>